import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { SpaceListItem } from "@ServerTypes/spaces/space.schema";

const saveSpaceSlice = createSlice({
  name: "save_space_List",
  initialState: [] as SpaceListItem[],
  reducers: {
    setSpaceList: (_state: SpaceListItem[], action: PayloadAction<SpaceListItem[]>) => action.payload,
  },
});

export const { setSpaceList } = saveSpaceSlice.actions;

export const save_space_List = saveSpaceSlice.reducer;

export default saveSpaceSlice.reducer;
